const topics = [
  {
    title: "Adding Fun",
    slug: "addingfun",
    standardNumber: "NC.2.OA.1",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Taking Away",
    slug: "takingaway",
    standardNumber: "NC.2.OA.1",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Odd Numbers",
    slug: "oddnumbers",
    standardNumber: "NC.2.OA.3",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Even Numbers",
    slug: "evennumbers",
    standardNumber: "NC.2.OA.3",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Place Value",
    slug: "placevalue",
    standardNumber: "NC.2.NBT.1",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Count By 5's",
    slug: "countby5s",
    standardNumber: "NC.2.NBT.2",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Count By 10's",
    slug: "countby10s",
    standardNumber: "NC.2.NBT.2",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Count By 100's",
    slug: "countby100s",
    standardNumber: "NC.2.NBT.2",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Expanded Form",
    slug: "expandedform",
    standardNumber: "NC.2.NBT.3",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Greater Than",
    slug: "greaterthan",
    standardNumber: "NC.2.NBT.4",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Adding Properties",
    slug: "addingproperties",
    standardNumber: "NC.2.NBT.5",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Add 3 Digits",
    slug: "add3digits",
    standardNumber: "NC.2.NBT.6",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Add By 10's",
    slug: "addby10s",
    standardNumber: "NC.2.NBT.8",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "English Ruler",
    slug: "englishruler",
    standardNumber: "NC.2.MD.1",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Metric Ruler",
    slug: "metricruler",
    standardNumber: "NC.2.MD.1",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Telling time",
    slug: "tellingtime",
    standardNumber: "NC.2.MD.7",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Dollars & Cents",
    slug: "dollarscents",
    standardNumber: "NC.2.MD.8",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Bargraph",
    slug: "bargraph",
    standardNumber: "NC.2.MD.10",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Pictograph",
    slug: "pictograph",
    standardNumber: "NC.2.MD.10",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Triangles",
    slug: "triangles",
    standardNumber: "NC.2.G.1",
    description: "Geometry",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Quadrilaterals",
    slug: "quadrilaterals",
    standardNumber: "NC.2.G.1",
    description: "Geometry",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Circles",
    slug: "circles",
    standardNumber: "NC.2.G.1",
    description: "Geometry",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  }
];
export default topics;